import dayjs from 'dayjs';
import { AuditOutlined } from '@ant-design/icons';
import { Card, DatePicker, Divider, Form, Input, Select } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { ICertificateKey } from 'interfaces/courses';
import { ICourseCertificate } from 'interfaces/course_certificate';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm, useSelect } from '@refinedev/antd';
import { fullNameValidatorRule } from 'utils/validators';

export const CertificateEdit = () => {
  const { formProps, saveButtonProps, queryResult } =
    useForm<ICourseCertificate>();

  const record = queryResult?.data?.data as ICourseCertificate | undefined;

  const { selectProps: certificateKeySelectProps } = useSelect<ICertificateKey>(
    {
      resource: 'certificate_keys',
      optionLabel: 'key',
      optionValue: 'key',

      pagination: {
        mode: 'server'
      }
    }
  );

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar certificado">
      <PageHeader
        title={record?.recipient_name || 'Editar certificado'}
        icon={AuditOutlined}
      />
      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item label="Usuário">
            <Input value={record?.user?.email || ''} disabled />
          </Form.Item>
          <Form.Item
            label="Nome"
            name="recipient_name"
            rules={[
              { required: true, message: 'Campo obrigatório' },
              fullNameValidatorRule('Nome')
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Curso"
            name="course_name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Duração (horas)"
            name="duration_in_hours"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            label="Template"
            name="template_key"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select {...certificateKeySelectProps} />
          </Form.Item>
          <Form.Item
            label="Data de conclusão"
            name="completed_at"
            rules={[
              {
                required: true
              }
            ]}
            getValueProps={value => ({ value: value ? dayjs(value) : '' })}
          >
            <DatePicker format="DD/MM/YYYY" />
          </Form.Item>
        </Form>

        <Divider />
      </Card>
    </EditLayout>
  );
};
